import React, { PureComponent } from 'react';
import classnames from 'classnames';
import { PageCard } from 'omni-common-ui';
import SimpleTable from 'components/SimpleTable';
import styles from './style.postcss';
import PropTypes from 'prop-types';

class OverallDevelopmentCard extends PureComponent {
  _renderHeader(abilities) {
    return (<SimpleTable.Header>
      <SimpleTable.Row>
        <SimpleTable.Cell columnId={{ columnId: 'skill' }} key={0} />
        {abilities
          .sort((a, b) => b.point - a.point)
          .map((ability) => <SimpleTable.Cell key={ability.abilityId}
              columnId={{ columnId: 'ability', ability }}>
            {ability.name}
          </SimpleTable.Cell>
          )}
      </SimpleTable.Row>
    </SimpleTable.Header>);
  }

  _renderBody(skillMap, subSkillMap) {
    return (<SimpleTable.Body>
      {({ skillResult }, { columnId, ability }) => {
        if (columnId === 'skill') {
          return <SimpleTable.Cell>{skillMap.get(skillResult.skillId)}</SimpleTable.Cell>;
        }

        const items = skillResult.subSkillResults
          .filter((ssr) => ssr.currentResultAbilityId === ability.abilityId)
          .map((ssr) => ({ uid: ssr.subSkillId, value: subSkillMap.get(ssr.subSkillId) }));

        if (items.length === 0) {
          return <SimpleTable.Cell />;
        } else if (items.length === 1) {
          return <SimpleTable.Cell>{items[0].value}</SimpleTable.Cell>;
        }

        return <SimpleTable.Cell>
          <ul>{items.map((item) =>
            <li key={item.uid} style={{ textAlign: 'left' }}>{item.value}</li>)}</ul>
        </SimpleTable.Cell>;
      }}
    </SimpleTable.Body>
    );
  }

  render() {
    const { className, skills, skillResults } = this.props;

    const skillMap = new Map();
    const subSkillMap = new Map();
    const abilities = skills.get(0).abilities;
    skills.forEach((skill) => {
      if (! skillMap.has(skill.skillId)) {
        skillMap.set(skill.skillId, skill.name);
      }

      skill.subSkills.forEach((subSkill) => {
        if (! subSkillMap.has(subSkill.subSkillId)) {
          subSkillMap.set(subSkill.subSkillId, subSkill.name);
        }
      });
    });

    const rows = skillResults.toList().map((skillResult) => ({ skillResult }));

    return <PageCard className={classnames(className, styles.OverallDevelopmentCard)}>
      <PageCard.Heading text="Overall Development" />
      <PageCard.Content>
        <SimpleTable rows={rows}>
          {this._renderHeader(abilities)}
          {this._renderBody(skillMap, subSkillMap)}
        </SimpleTable>
      </PageCard.Content>
    </PageCard>;
  }
}

OverallDevelopmentCard.propTypes = {
  className: PropTypes.string,
  skills: PropTypes.object,
  skillResults: PropTypes.object,
};

export default OverallDevelopmentCard;



// WEBPACK FOOTER //
// ./containers/Group/UnitReportHFv4/StudentReportView/OverallDevelopmentCard/index.jsx